import type { Phrase, Section } from '../types';
import { common } from './common';
import { guest } from './guest';
import { ops } from './ops';
import { agenda } from './agenda';
import { power } from './power';

/**
 * One flat dictionary. Keys are dotted and namespaced by shell so a guest
 * screen and an ops screen can never collide.
 *
 * Adding a key: put it in the section it belongs to, give it es and en, run
 * `pnpm --filter @dia/i18n test`. The test refuses a key that is missing a
 * language, is empty, or contains an em dash.
 */
export const dictionary = { ...common, ...guest, ...ops, ...agenda, ...power } as const;

export type DictionaryKey = keyof typeof dictionary;

export const sections: Record<string, Section> = { common, guest, ops, agenda, power };

export function phrase(key: DictionaryKey): Phrase {
  return dictionary[key];
}

export { common, guest, ops, agenda, power };
